import * as React from "react"
import * as Model from "../../../../model"

export default class DOBFormPart
extends React.Component<Props, State> {
	render() {		
		return <section className="section">
			<h2>Débat d'orientation budgétaire</h2>

			<div className="columns is-multiline">
				{this.getSectionsConfiguration().map((conf, i) =>
					<section
					className="column is-full is-half-tablet is-one-third-widescreen section"
					key={i}>
						<h3 className="title">{conf.title}</h3>
						{this.renderFields(conf.tables)}
						{this.renderFields(conf.charts)}
					</section>
				)}
			</div>
		</section>
	}

	private getSectionsConfiguration(): SectionConfiguration[] {
		const insertDobTableLabel = "Inclure le tableau de prospective DOB"	

		return [
			{				
				tables: {
					label: insertDobTableLabel,
					name: Names.DOB.Tables
				},
				title: "Récapitulatif"
			}			
		]
	}

	private renderField(
		name: string,
		label: string,
		key?: number,
		disabled?: boolean
): React.ReactNode {
		return <div className="field" key={key}>
			<label className="checkbox">
				<input name={name} type="checkbox" checked={this.props.report && this.props.report.includes(name)} disabled={disabled}/>&nbsp;{label}
			</label>
		</div>
	}

	private renderFields(
		confItem: SectionConfigurationItem,
	): React.ReactNodeArray {
		if (!confItem) return null

		const parentField = this.renderField(confItem.name, confItem.label, 0, this.props.disabled)

		if (!(confItem.details && confItem.details.length)) return [parentField]

		return confItem.details.reduce((fields, detail, i) => {
			if (!detail.name) return fields
			return [
				...fields,
				this.renderField(detail.name, detail.title, i + 1, this.props.disabled)
			]
		}, [parentField])
	}
}

export const Names = {
    DOB:{
        Tables:"dob-prospective-table"
    }	
}

export interface Props {
	disabled?: boolean
	report?: any
}

interface SectionConfiguration {
	charts?: SectionConfigurationItem
	tables?: SectionConfigurationItem
	title: string
}

interface SectionConfigurationItem {
	label: string
	name: string
	details?: SectionDetailConfiguration[],
}

interface SectionDetailConfiguration {
	name: string
	title: string
}

interface State {}



// WEBPACK FOOTER //
// ./src/component/management-report/form-parts/dob-from-part/index.tsx